export { default } from './ProductsSection';
